import { createTheme } from '@mui/material/styles';

import { getTheme } from '@cw-ui/asio-neon-themes';

const FALLBACK_THEME = createTheme();

export const resolveAppTheme = () => {
  try {
    const theme = getTheme('light');
    if (theme) {
      return theme;
    }
  } catch {
    // Fall back to a default MUI theme when the design-system theme is unavailable.
  }

  return FALLBACK_THEME;
};
